
const modules = [
  {
    name: 'Typography',
    loader: () => import('./components/Typography'),
  },
  {
    name: 'FormAnimation',
    loader: () => import('./components/FormAnimation'),
  },
  {
    name: 'SelectC8',
    loader: () => import('./components/SelectC8'),
  },
  {
    name: 'TabList',
    loader: () => import('./modules/TabList'),
  },
  {
    name: 'ModAccordion',
    loader: () => import('./modules/ModAccordion'),
  },
  {
    name: 'ModImageWithContentBox',
    loader: () => import('./modules/ModImageWithContentBox'),
  },
  {
    name: 'ModCampusDataCenter',
    loader: () => import('./modules/ModCampusDataCenter'),
  },
  {
    name: 'ModExploreMarkets',
    loader: () => import('./modules/ModExploreMarkets'),
  },
  {
    name: 'ModFilterResources',
    loader: () => import('./modules/ModFilterResources'),
  },
  {
    name: 'ModFilterNews',
    loader: () => import('./modules/ModFilterNews'),
  },
  {
    name: 'ModCareers',
    loader: () => import('./modules/ModCareers'),
  },
  {
    name: 'ModImageGrid',
    loader: () => import('./modules/ModImageGrid'),
  },
  {
    name: 'ModRightMenu',
    loader: () => import('./modules/ModRightMenu'),
  },
  {
    name: 'ModLocationCarousel',
    loader: () => import('./modules/ModLocationCarousel'),
  },
  {
    name: 'ModTabImage',
    loader: () => import('./modules/ModTabImage'),
  },
  {
    name: 'ModMediaGrid',
    loader: () => import('./modules/ModMediaGrid'),
  },
  {
    name: 'ModGiantImageVideo',
    loader: () => import('./modules/ModGiantImageVideo'),
  },
  {
    name: 'ModScrollActivatedVideo',
    loader: () => import('./modules/ModScrollActivatedVideo'),
  },
  {
    name: 'ModCampusesCarousel',
    loader: () => import('./modules/ModCampusesCarousel'),
  },
  {
    name: 'ModTeamMemberListing',
    loader: () => import('./modules/ModTeamMemberListing'),
  },
  {
    name: 'ModTilesSlider',
    loader: () => import('./modules/ModTilesSlider'),
  },
  {
    name: 'ModContactForm',
    loader: () => import('./modules/ModContactForm'),
  },
  {
    name: 'ModResourceDetail',
    loader: () => import('./modules/ModResourceDetail'),
  },
  {
    name: 'ModBioSlider',
    loader: () => import('./modules/ModBioSlider'),
  },
  {
    name: 'ModImageCollapseContent',
    loader: () => import('./modules/ModImageCollapseContent'),
  },
  {
    name: 'ModLeftRightLanding',
    loader: () => import('./modules/ModLeftRightLanding'),
  },
  {
    name: 'ModInteractiveGlobe',
    loader: () => import('./modules/ModInteractiveGlobe'),
  },
  {
    name: 'ModInteractiveCampus',
    loader: () => import('./modules/ModInteractiveCampus'),
  },
  {
    name: 'ModFullPageSection',
    loader: () => import('./modules/ModFullPageSection'),
  },
  {
    name: 'ModSearchResult',
    loader: () => import('./modules/ModSearchResult'),
  },
  {
    name: 'ModBannerLanding',
    loader: () => import('./modules/ModBannerLanding'),
  },
  {
    name: 'ModIconAndTextCard',
    loader: () => import('./modules/ModIconAndTextCard'),
  },
];

export default [...modules];
